module.exports = __webpack_public_path__ + "static/media/close-rounded-black.b71bb724.svg";